import { createContext, useContext } from 'react';
import { FormNodeNameType } from '../../../../shared/kiosk/models';
import { Option } from '../../../../shared/options';

export interface OptionContextProps {
  config: KioskEditorConfiguration;
  options: Option[];
}

export interface KioskEditorConfiguration {
  multiplePages: boolean;
  allowCss: boolean;
  formTypes: FormNodeNameType[];
  finalPage?: {
    formTypes: FormNodeNameType[];
  };
}

export const RegFormEditorConfig: KioskEditorConfiguration = {
  multiplePages: false,
  allowCss: false,
  formTypes: [
    'markdown',
    'login',
    'divider',
    'option',
    'subheader',
    'termsAgreement',
    'linkTermsAgreement',
    'attendanceFlags',
    'emergencyContacts',
    'badgePreview',
    'submit',
    'randomizeButton',
    'badgeArtSelector',
    'otherOptions',
    'profilePicture',
    'pii',
  ],
};

export const ExpressEditorOptionContext = createContext<OptionContextProps>({
  config: RegFormEditorConfig,
  options: [],
});

export function useExpressEditorOptions(): Option[] {
  return useContext(ExpressEditorOptionContext).options;
}

export function useExpressEditorConfig(): KioskEditorConfiguration {
  return useContext(ExpressEditorOptionContext).config;
}
